



































import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import RadioBoxes from '../radios/RadioBoxes.vue';
import RadioBox from '../radios/RadioBox.vue';
import { ConstructionTypeEnum } from '../../domain/webservice-dto';
import { Action, Getter } from 'vuex-class';
import { ConstructionStoreActions, ConstructionStoreGetters } from '../../store/ConstructionTypes';
import { Form } from './Form';
import { addTargetPageName, isCorporateCustomersSection } from '../../utils/magnolia-utils';

@Component({
    components: {
        RadioBoxes,
        RadioBox,
    },
})
export default class ConstructionTypeForm extends Vue implements Form {

    public constructionType?: ConstructionTypeEnum | string = '';
    public isTouched = false;

    @Getter(ConstructionStoreGetters.ConstructionType)
    private readonly constructionTypeValue!: ConstructionTypeEnum;

    @Action(ConstructionStoreActions.SaveConstructionType)
    private saveConstructionType!: (constructionType?: ConstructionTypeEnum) => void;

    get hasError() {
        return this.isTouched && !this.constructionType;
    }

    public buildUrlForOtherForm(url: string): string {
        return addTargetPageName(url, isCorporateCustomersSection(window.location.href));
    }

    public mounted() {
        this.constructionType = this.constructionTypeValue;
        this.validationChange();
    }

    public touch() {
        this.isTouched = true;
    }

    public save() {
        this.saveConstructionType(
            this.constructionType !== '' ? this.constructionType as ConstructionTypeEnum : undefined,
        );
    }

    @Emit()
    @Watch('constructionType')
    public validationChange() {
        return this.constructionType === undefined || this.constructionType === '';

    }

}
